module.exports = __webpack_public_path__ + "images/init-progress@2x-a6eebc928cb82edc8f5a612c09f88e80.png";